import React from 'react'

import type { PresentationBlockProps } from '../../'
import compareBlockProps from '../../util/compareBlockProps'

import { Grid, makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'

import { socialLinkTypesByLabel } from './socialLinkTypes'
import { sanitizeHref } from './sanitizeHref'

const useStyles = makeStyles<Theme, PresentationBlockProps>(
  (_theme: Theme) => {
    return {
      root: {},
      linkIcon: (props) => ({
        fontSize: props.block.fields?.fontSize,
        '&:hover': {
          opacity: 0.8
        }
      })
    }
  },
  { name: 'SocialLinksBlock' }
)

const getIcon = (label: string, className: string) => {
  const Icon = socialLinkTypesByLabel[label]?.Icon
  return Icon ? <Icon className={className} /> : null
}

const getHref = (link: { label: string; href: string }) => {
  const { prefix = '' } = socialLinkTypesByLabel[link.label] ?? {}
  return sanitizeHref(`${prefix}${link.href}`)
}

function SocialLinksBlock(props: PresentationBlockProps) {
  const { block, WrapperComponent, isEditable, isSettings } = props
  const classes = useStyles(props)
  const { links, alignment } = block.fields

  const activeLinks = (links ?? []).filter((link) => {
    return link.href.length
  })

  return (
    <WrapperComponent {...props}>
      <Grid container spacing={2} justifyContent={alignment}>
        {(isEditable || !isSettings) && (
          <>
            {activeLinks.map((link) => {
              return (
                <Grid item key={link.label}>
                  <a href={getHref(link)} target="_blank" rel="noopener noreferrer">
                    {getIcon(link.label, classes.linkIcon)}
                  </a>
                </Grid>
              )
            })}
          </>
        )}
        {!isEditable && isSettings && (
          <>
            {activeLinks.map((link) => {
              return (
                <Grid item key={link.label}>
                  <span>{getIcon(link.label, `${classes.linkIcon} themeAccent`)}</span>
                </Grid>
              )
            })}
          </>
        )}
      </Grid>
    </WrapperComponent>
  )
}

export default React.memo(SocialLinksBlock, (prevProps, nextProps) => {
  return compareBlockProps(prevProps, nextProps)
})
